import { render, staticRenderFns } from "./BlogSidebar.vue?vue&type=template&id=0f39ad0a&"
import script from "./BlogSidebar.vue?vue&type=script&lang=js&"
export * from "./BlogSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BlogSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports